import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ArrowDown } from "lucide-react";
import { processData } from "../../../../data/howItWorks/processData";
import "./HowItWorksHero.css";

const HowItWorksHero = () => {
  const heroRef = useRef(null);
  const badgeRef = useRef(null);
  const headlineRef = useRef(null);
  const descriptionRef = useRef(null);
  const arrowRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ delay: 0.2 });

      tl.from(badgeRef.current, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: "power3.out",
      })
        .from(
          headlineRef.current,
          {
            opacity: 0,
            y: 40,
            duration: 1,
            ease: "power3.out",
          },
          "-=0.5",
        )
        .from(
          descriptionRef.current,
          {
            opacity: 0,
            y: 30,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.6",
        )
        .from(
          arrowRef.current,
          {
            opacity: 0,
            y: -20,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.4",
        );

      // Floating arrow animation
      gsap.to(arrowRef.current, {
        y: 10,
        duration: 1.5,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
      });
    }, heroRef);

    return () => ctx.revert();
  }, []);

  const scrollToFunnel = () => {
    const funnelSection = document.querySelector(".process-funnel");
    if (funnelSection) {
      funnelSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="how-it-works-hero" ref={heroRef}>
      <div className="how-it-works-hero__container">
        <div className="how-it-works-hero__badge" ref={badgeRef}>
          {processData.hero.badge}
        </div>
        <h1 className="how-it-works-hero__headline" ref={headlineRef}>
          {processData.hero.headline}
        </h1>
        <p className="how-it-works-hero__description" ref={descriptionRef}>
          {processData.hero.description}
        </p>

        <button
          className="how-it-works-hero__scroll"
          onClick={scrollToFunnel}
          ref={arrowRef}
        >
          <ArrowDown size={32} strokeWidth={1.5} />
        </button>
      </div>
    </section>
  );
};

export default HowItWorksHero;
